import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Company, CompanyCreateRq, CompanyEditRq } from '../models/shared/company';
import { sizePage } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  constructor(private readonly http: HttpClient) {
  }

  GetCompanyList(pData: string, page: number): Observable<any> {
    page--;
    return this.http.get<any>('/company/page/' + page + '?size=' + sizePage + "&" + pData, { observe: 'response' });
  }

  GetCompaniesList(): Observable<any> {
    return this.http.get<any>('/company/', { observe: 'response' });
  }

  GetServicesList(): Observable<any> {
    return this.http.get<any>('/company/services/001', { observe: 'response' });
  }

  GetCompanyDetail(pData: string): Observable<any> {
    return this.http.get<any>('/company/' + pData, { observe: 'response' });
  }


  GetSeccionsByCompany(pCompanyId: string, parentId: string = "3"): Observable<any> {
    return this.http.get<any>('/company/sections/' + pCompanyId + '/' + parentId, { observe: 'response' });
  }

  /** Get List of providers for configurate the company */
  public getProvidersForCompany(): Observable<any> {
    return this.http.get<any>(`/company/providers`);
  }

  CreateCompanyDetail(pData: CompanyCreateRq): Observable<any> {
    return this.http.post<any>('/company/',
      pData, { observe: 'response' });
  }

  EditCompanyDetail(pId: string, pData: CompanyEditRq): Observable<any> {
    console.log("EditCompanyDetail", pId, pData);
    return this.http.put<any>('/company/' + pId, pData, { observe: 'response' });
  }

  DeleteCompanyDetail(pData: Company): Observable<any> {
    let _parameters = pData.id;
    return this.http.delete<any>('/company/' +
      _parameters, { observe: 'response' });
  }

  GetSectionsList(): Observable<any> {
    return this.http.get<any>('/company/sections/', { observe: 'response' });
  }

  public getQuestionsList(): Observable<any> {
    return this.http.get<any>(`/company/qconfig/`, { observe: 'response' })
  }

  public getConfigCompany(idCompany: string): Observable<any> {
    return this.http.get<any>(`/company/configuration/${idCompany}`);
  }

  public getProvidersCaeList(): Observable<any> {
    return this.http.get<any>(`/company/assistance/providers`, { observe: 'response' })
  }

  public async syncCompany(companyId: any, userId: any) {
    const url = `/sync/?companyId=${companyId}&userId=${userId}`;
    console.log("syncCompany", url);
    const response = await this.http.put(url, null).toPromise();
    return response;
  }

}
